import React, { Fragment, useState } from 'react';

import { CreationAccountRow, PostCreationAccountInput, SnsType } from '@/api/creation';
import { ReactComponent as TikTokIcon } from '@/assets/tiktok.svg';
import { ReactComponent as TwitterIcon } from '@/assets/TwitterLogo.svg';
import { ReactComponent as YoutubeIcon } from '@/assets/youtube.svg';
import { Button } from '@/components/Elements';

import { ReactComponent as PlusCircleImage } from './assets/bx-plus-circle.svg';
import { ReactComponent as PlusImage } from './assets/bx-plus.svg';
import { ReactComponent as InstagramIcon } from './assets/Instagram_Glyph_Gradient_RGB.svg';
import SnsAccountRegisterModal from './SnsAccountRegisterModal';

interface AccountViewProps {
  accounts: CreationAccountRow[];
  selectAccount: CreationAccountRow;
  setSelectAccount: React.Dispatch<React.SetStateAction<CreationAccountRow>>;
  addAccount: (input: PostCreationAccountInput) => void;
}

export const AccountView = (props: AccountViewProps) => {
  const [openRegisterModal, setOpenRegisterModal] = useState<boolean>(false);
  const handleOpenRegisterModal = () => {
    setOpenRegisterModal(true);
  };

  const SnsIcon = (snsType: SnsType) => {
    switch (snsType) {
      case SnsType.Instagram:
        return <InstagramIcon width={20} height={20} />;
      case SnsType.X:
        return <TwitterIcon width={20} height={20} />;
      case SnsType.TikTok:
        return <TikTokIcon width={20} height={20} />;
      case SnsType.Youtube:
        return <YoutubeIcon width={20} height={20} />;
    }
  };

  return (
    <>
      <div className="ml-[16px] mt-[17px] w-[203px]">
        {props.accounts.length > 0 ? (
          <div className="h-[525px] w-[203px] overflow-auto">
            {props.accounts.map((account, index) => (
              <button
                key={index}
                onClick={() => props.setSelectAccount(account)}
                className={`${
                  props.selectAccount.id === account.id && props.selectAccount.snsType === account.snsType
                    ? 'mb-[8px] flex items-center justify-around rounded-lg bg-gray-200 py-[8px] pl-[8px] pr-[10px]'
                    : 'mb-[8px] flex items-center justify-around rounded-lg py-[8px] pl-[8px] pr-[10px] hover:bg-gray-200'
                }`}
              >
                {SnsIcon(account.snsType)}
                <p className="w-[124px] text-sm font-medium leading-5 text-gray-900">{account.name}</p>
              </button>
            ))}
            <button onClick={handleOpenRegisterModal}>
              <div className="mt-[8px] flex w-[147px] items-center justify-around py-[2px] pr-[17px]">
                <PlusCircleImage width={24} height={24} />
                <p className="text-sm font-medium leading-5 text-gray-400">アカウント追加</p>
              </div>
            </button>
          </div>
        ) : (
          <div>
            <p className="mb-[16px] w-[208px] text-center text-[14px] font-normal leading-6 text-[#6B7280]">
              SNSアカウントが登録されていません。登録してみましょう！
            </p>
            <Button
              startIcon={<PlusImage className="h-[20px] w-[20px]" />}
              size="md"
              className="whitespace-nowrap text-sm font-medium leading-5"
              style={{
                margin: 'auto',
                paddingTop: '9px',
                paddingBottom: '9px',
                paddingLeft: '10px',
                paddingRight: '12px',
              }}
              onClick={handleOpenRegisterModal}
            >
              SNSアカウントを登録
            </Button>
          </div>
        )}
      </div>
      <div className="relative">
        <SnsAccountRegisterModal
          open={openRegisterModal}
          addAccount={props.addAccount}
          closeModal={() => {
            setOpenRegisterModal(false);
          }}
        />
      </div>
    </>
  );
};
